import { BusinessUser } from '@models/businesses';
import { IntakeFormStatus, ClientIntakeForm } from '@models/client-intake';
import { PortalInvitee, PortalInvite } from '@models/portal-invites';
import { DropdownItem } from '@ui/dropdown/dropdown.component';

export interface IntakeHeaderViewModel {
	backLabel: string;
	primaryAction: { label: string; icon: string };
	title: string;
	dropdownItem: DropdownItem | null;
	matterId: string;
	intakeForm: ClientIntakeForm | null;
	portalInvite: PortalInvite | null;
	loggedInUser: BusinessUser | null;
	inviteStatus: {
		isDraft: boolean | null;
		isActive: boolean | null;
	};
	inviteContainsInvitees: boolean | null;
}

export interface ShareIntakeFormModalViewModel {
	clientDropdownItems: ClientDropdownItem[];
	intakeForm: ClientIntakeForm | null;
	portalInvite: PortalInvite | null;
	sortedInvitees: PortalInvitee[];
}

export const intakeHeaderViewModel: IntakeHeaderViewModel = {
	backLabel: 'Back',
	primaryAction: { label: 'Send', icon: 'send' },
	title: 'Client Intake Request',
	dropdownItem: null,
	matterId: '',
	intakeForm: null,
	portalInvite: null,
	loggedInUser: null,
	inviteStatus: {
		isDraft: null,
		isActive: null,
	},
	inviteContainsInvitees: null,
};

export interface IntakeDropdownViewModel {
	intakeForm: ClientIntakeForm | null;
	dropdownItem: DropdownItem | null;
	matterId: string | null;
}

export const intakeDropdownViewModel: IntakeDropdownViewModel = {
	intakeForm: null,
	dropdownItem: null,
	matterId: null,
};

export const IntakeFormStatusDropdownOptions: DropdownItem[] = [
	{
		id: IntakeFormStatus.DRAFT,
		title: {
			label: 'Draft',
			icon: 'circle-dotted',
		},
	},
	{
		id: IntakeFormStatus.WAITING_FOR_UPDATES,
		title: {
			label: 'Waiting for updates',
			icon: 'progress-check',
			iconClasses: 'text-blue-600',
		},
	},
	{
		id: IntakeFormStatus.REVIEW_UPDATES,
		title: {
			label: 'Ready to review',
			icon: 'progress-check',
			iconClasses: 'text-amber-600',
		},
	},
	{
		id: IntakeFormStatus.COMPLETE,
		title: {
			label: 'Complete',
			icon: 'progress-check',
			iconClasses: 'text-green-600',
		},
	},
	{
		id: IntakeFormStatus.CANCELLED,
		title: {
			label: 'Cancelled',
			icon: 'circle-dotted',
		},
	},
];
export interface ClientDropdownItem {
	name: string;
	value: PortalInvitee;
}

export interface IntakeFormDropdownItem {
	name: string;
	form: ClientIntakeForm;
}

export interface IntakePageViewModel {
	intakeForm: ClientIntakeForm | null;
	portalInvite: PortalInvite | null;
}

export const intakePageViewModel: IntakePageViewModel = {
	intakeForm: null,
	portalInvite: null,
};

export enum IntakeFormMode {
	PREVIEW = 'preview',
	EDIT = 'edit',
}

export interface IntakeStatusDisplayViewModel {
	intakeStatusDisplay: {
		label: string;
		icon?: string;
		iconClasses?: string;
	} | null;
}

export const intakeStatusDisplayViewModel: IntakeStatusDisplayViewModel = {
	intakeStatusDisplay: null,
};
